/**
 * Barrel file: re-exports all rule utilities from focused modules.
 */
// ─── Re-exports ──────────────────────────────────────────────────────────────
// rule-types
export { defaultEnglishTranslations } from './rule-types';
// rule-keyword-utils
export { escapeRegex as escapeRegexCharacters, extractKeywordFromConditions, extractKeywordFromRegex, findDescriptionCondition, isDescriptionCondition, keywordToRegexPattern, updateConditionWithKeyword, } from './rule-keyword-utils';
// rule-accessors
export { getActions, getAppliedCategory, getConditions, } from './rule-accessors';
// rule-mutators
export { changeAppliedCategory, changeKeyword } from './rule-mutators';
// rule-conversion
export { fromStructured, toStructured } from './rule-conversion';
// rule-human-readable
export { aiConditionToHumanReadable, buildActionText, buildConditionText, normalizeFieldName, } from './rule-human-readable';
// rule-filter-conversion
export { filtersToRulePresets } from './rule-filter-conversion';
// rule-trigger-helpers
export { formatTriggerText, getTriggerTypeLabel, Operators, translateTrigger, } from './rule-trigger-helpers';
// ─── rawRulesUtils compat object ─────────────────────────────────────────────
import { getActions, getAppliedCategory, getConditions, } from './rule-accessors';
import { fromStructured, toStructured } from './rule-conversion';
import { changeAppliedCategory, changeKeyword } from './rule-mutators';
import { formatTriggerText, getTriggerTypeLabel, translateTrigger, } from './rule-trigger-helpers';
export const rawRulesUtils = {
    toStructured,
    fromStructured,
    changeAppliedCategory,
    changeKeyword,
    getAppliedCategory,
    getConditions,
    getActions,
    getTriggerTypeLabel,
    formatTriggerText,
    translateTrigger,
};
// ─── createRuleUtils factory ─────────────────────────────────────────────────
import { aiConditionToHumanReadable } from './rule-human-readable';
import { escapeRegex, extractKeywordFromConditions, extractKeywordFromRegex, findDescriptionCondition, isDescriptionCondition, keywordToRegexPattern, updateConditionWithKeyword, } from './rule-keyword-utils';
export function createRuleUtils(options) {
    const defaultTranslations = options?.translations;
    return {
        keyword: {
            escapeRegex,
            toPattern: keywordToRegexPattern,
            fromPattern: extractKeywordFromRegex,
            findDescription: findDescriptionCondition,
            extractFromConditions: extractKeywordFromConditions,
            updateCondition: updateConditionWithKeyword,
            isDescriptionCondition,
        },
        convert: {
            toStructured,
            fromStructured,
        },
        mutate: {
            changeCategory: changeAppliedCategory,
            changeKeyword,
        },
        get: {
            category: getAppliedCategory,
            conditions: getConditions,
            actions: getActions,
        },
        toHumanReadable: (condition, opts) => {
            const mergedOpts = defaultTranslations
                ? { translations: defaultTranslations, ...opts }
                : opts;
            return aiConditionToHumanReadable(condition, mergedOpts);
        },
    };
}
/** Default instance for convenience */
export const ruleUtils = createRuleUtils();
